import AuthRoute from './auth-route';
import { PrivateRoutes } from './private-route';
import { UnauthorizedRoutes } from './unauthorized-routes';
import { Logout } from 'features/auth/components/logout';
import { useAuth } from 'features/auth/contexts/auth';
import { AppStoreProvider } from 'features/settings/contexts/settings.context';
import MainApp from 'main-app';
import { ErrorsPage } from 'pages/errors';
import { FC } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;

const AppRoutes: FC = () => {
  const { currentUser } = useAuth();

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<MainApp />}>
          <Route path="logout" element={<Logout />} />
          <Route path="external/*" element={<UnauthorizedRoutes />} />
          <Route path="error/*" element={<ErrorsPage />} />

          <Route index element={<Navigate to="/dashboard" />} />

          <Route
            path="/*"
            element={
              currentUser ? (
                <AppStoreProvider>
                  <PrivateRoutes />
                </AppStoreProvider>
              ) : (
                <AuthRoute />
              )
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export { AppRoutes };
